"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecoreCard = RecoreCard;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _link = _interopRequireDefault(require("../../elements/buttons/link"));
var _card = _interopRequireDefault(require("../../elements/other/card"));
var _image = require("@site/pattern-library-core/image");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _recorePlanboxModal = _interopRequireDefault(require("./recore-planbox-modal"));
var _videoCard = _interopRequireDefault(require("./common/video-card"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

/**
 * Local Imports
*/

const desktopLgBreakpoint = _patternLibraryUtils.device.desktop;
const tabletBreakpoint = _patternLibraryUtils.deviceMax.tabletLg;
const mobileBreakpoint = _patternLibraryUtils.deviceMax.mobile;
const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-c1hop8wt",
  vars: {
    "c1hop8wt-3": [({
      mobileStack
    }) => mobileStack ? '%100%' : '45%'],
    "c1hop8wt-9": [({
      bgImage,
      bgColor,
      borderColor
    }) => bgImage || bgColor ? '2px solid transparent' : `2px solid ${borderColor || `${_intents.default.ux.boxLowContrast.borderColor}`}`],
    "c1hop8wt-10": [({
      bgImage
    }) => bgImage ? `url("${bgImage}")` : 'none'],
    "c1hop8wt-11": [({
      bgColor
    }) => bgColor ?? `${_intents.default.ux.box.backgroundColor}`],
    "c1hop8wt-13": [({
      hasCta
    }) => hasCta ? 'pointer' : 'default']
  }
});
const ImageBlockContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageBlockContainer",
  class: "pl-i14iai0r",
  vars: {
    "i14iai0r-0": [({
      imageBgColor
    }) => imageBgColor ?? `none`]
  }
});
const CardImage = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "CardImage",
  class: "pl-c1en8pu8",
  vars: {
    "c1en8pu8-1": [({
      tablet: {
        url
      } = {}
    }) => url ? `url(${url})` : 'initial'],
    "c1en8pu8-4": [({
      landscape: {
        url
      } = {}
    }) => url ? `url(${url})` : 'initial'],
    "c1en8pu8-7": [({
      hideMobileImage
    }) => hideMobileImage ? 'none' : 'initial']
  }
});
const TextBlockContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TextBlockContainer",
  class: "pl-thg9zi5"
});
const CardText = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardText",
  class: "pl-c1q5ip9b",
  vars: {
    "c1q5ip9b-8": [({
      textFontSize
    }) => textFontSize || '0.875rem'],
    "c1q5ip9b-10": [({
      description
    }) => description ? 'initial' : 'none'],
    "c1q5ip9b-12": [({
      description,
      hideMobileDescription
    }) => description && !hideMobileDescription ? 'initial' : 'none']
  }
});
const CardCTA = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardCTA",
  class: "pl-cwxt8wn",
  vars: {
    "cwxt8wn-0": [({
      textFontSize
    }) => textFontSize || '0.875rem']
  }
});
const getCardLayoutType = ({
  cardSize
}) => {
  if (cardSize === 'lg') {
    return 'horiz';
  }
  return 'vert';
};
const getCardImage = ({
  cardSize,
  landscape,
  portrait
}) => {
  let image;
  if (cardSize === 'lg' && portrait?.url) {
    image = {
      ...portrait,
      type: 'portrait'
    };
  } else if (landscape?.url) {
    image = {
      ...landscape,
      type: 'landscape'
    };
  }
  return image;
};

/**
 * Recore Card component.
 *
 * @param {Object} props React props
 * @param {string} props.card Card component props
 * @param {string} props.cardSize size type of the card
 * @param {string} props.cta CTA Button or Link
 * @param {Object} props.landscape Wide image for small cards
 * @param {Object} props.portrait Tall image for large cards
 * @param {Object} props.tablet Tablet image for mobile layout
 * @param {string} props.imageBgColor Image background color
 * @param {string} props.backgroundColor Card background color
 * @param {string} props.backgroundImage Card background image
 * @param {string} props.textFontSize Text font size
 * @param {string} props.theme Optional Theme name for custom styling
 * @param {string} props.reversed Reverse card layout
 * @param {string} props.invert Invert card text/background colors
 * @param {String} props.partial Theme partial
 * @param {boolean} props.mobileStack dont let secondary cards go side by side
 * @param {boolean} props.hideMobileImage hide mobile imagery
 * @param {boolean} props.hideMobileDescription hide mobile descriptions
 * @returns {React.ReactElement} RecoreCard component
 * @public
 */
function RecoreCard(props) {
  const {
    imageBgColor,
    landscape,
    portrait,
    tablet,
    backgroundImage,
    backgroundColor,
    borderColor,
    card = {
      padding: 'none',
      indented: true,
      textAlign: 'start',
      headlineSize: 'h4',
      className: 'card-headline'
    },
    cardSize = 'sm',
    reversed = false,
    invert = false,
    planbox,
    textFontSize = '14px',
    theme,
    cta = {
      templateName: 'Link',
      external: true,
      design: 'arrow'
    },
    constrain = 'large',
    mobileStack = false,
    hideMobileDescription = false,
    hideMobileImage = false,
    introUrl,
    introUrlWebm,
    thumbnail,
    preload,
    partial = ''
  } = props || {};
  const cardRef = (0, _react.useRef)();
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const {
    ctaRef
  } = (0, _patternLibraryUtils.useTrackingUpdate)(cta);
  const hasCta = !!cta && cta instanceof Object && Object.keys(cta).length > 0;
  if (hasCta && planbox) {
    const hrefOnClick = cta.onClick || (() => {});
    cta.onClick = evt => {
      setShowModal(true);
      hrefOnClick(evt);
    };
  }
  const closeModal = () => {
    setShowModal(false);
  };
  const handleClick = () => {
    hasCta && (0, _patternLibraryUtils.getClickable)({
      ref: cardRef
    })?.click();
  };
  const image = getCardImage(props);
  const type = getCardLayoutType(props);
  const themeClass = theme ? `theme-${theme}` : '';
  const reversedClass = reversed && 'card-reversed ' || '';
  const className = `card-${cardSize} card-${type} card-constrain-${constrain} ${reversedClass} ${themeClass}`;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CardContainer, {
    ref: cardRef,
    hasCta: hasCta,
    "aria-label": hasCta ? cta.ariaLabel : null,
    "data-cy": "recore-card",
    onClick: () => handleClick(),
    bgColor: backgroundColor && (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    bgImage: backgroundImage?.url,
    borderColor: borderColor && (0, _patternLibraryUtils.getBackgroundColor)(borderColor),
    cardSize: cardSize,
    reversed: reversed,
    mobileStack: mobileStack,
    "data-partial": partial || (invert ? 'dark1' : ''),
    className: className
  }, /*#__PURE__*/_react.default.createElement(ImageBlockContainer, {
    "data-cy": "recore-card-image-block",
    imageBgColor: (0, _patternLibraryUtils.getBackgroundColor)(imageBgColor),
    className: `image-block-${image?.type}`
  }, image && /*#__PURE__*/_react.default.createElement(CardImage, {
    dataCy: "recore-card-image",
    url: image?.url,
    altText: image?.altText,
    initialInView: true,
    className: `card-image image-${image?.type} card-constrain-${constrain}`,
    containerClassName: "card-image-wrapper",
    landscape: landscape,
    portrait: portrait,
    tablet: tablet,
    hideMobileImage: hideMobileImage
  }), !image && /*#__PURE__*/_react.default.createElement(_videoCard.default, {
    introUrl,
    introUrlWebm,
    thumbnail,
    preload
  })), /*#__PURE__*/_react.default.createElement(TextBlockContainer, {
    "data-cy": "recore-card-text-block"
  }, /*#__PURE__*/_react.default.createElement(CardText, {
    "data-cy": "recore-card-text",
    cardSize: cardSize,
    textFontSize: textFontSize,
    hasCta: hasCta,
    description: card?.description,
    hideMobileDescription: hideMobileDescription,
    bgColor: backgroundColor && (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, /*#__PURE__*/_react.default.createElement(_card.default, (0, _extends2.default)({
    padding: "none",
    indented: true,
    textAlign: "start"
  }, card, {
    className: `card-headline ${card?.className}`
  }))), hasCta && /*#__PURE__*/_react.default.createElement(CardCTA, {
    "data-cy": "recore-card-cta",
    className: `recore-card-cta-${cardSize}`,
    ref: ctaRef,
    mobileStack: mobileStack
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    templateMap: {
      Link: _link.default
    },
    buttons: [cta]
  })))), showModal && /*#__PURE__*/_react.default.createElement(_recorePlanboxModal.default, (0, _extends2.default)({}, planbox, {
    onClose: closeModal
  })));
}
var _default = exports.default = RecoreCard;
RecoreCard.propTypes = {
  cardSize: _propTypes.default.oneOf(['sm', 'lg']),
  reversed: _propTypes.default.bool,
  invert: _propTypes.default.bool,
  landscape: _propTypes.default.shape(_image.imgPropShape),
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tablet: _propTypes.default.shape(_image.imgPropShape),
  imageBgColor: _patternLibraryUtils.getBackgroundColor.propTypes.backgroundColor,
  backgroundImage: _propTypes.default.shape(_image.imgPropShape),
  backgroundColor: _patternLibraryUtils.getBackgroundColor.propTypes.backgroundColor,
  card: _propTypes.default.object,
  textFontSize: _propTypes.default.string,
  theme: _propTypes.default.string,
  cta: _propTypes.default.shape({
    templateName: _propTypes.default.string,
    external: _propTypes.default.bool,
    design: _propTypes.default.string,
    as: _propTypes.default.string,
    ariaLabel: _propTypes.default.string,
    text: _propTypes.default.string.isRequired,
    href: _propTypes.default.string.isRequired,
    _name: _propTypes.default.string.isRequired
  }),
  hideMobileDescription: _propTypes.default.bool,
  hideMobileImage: _propTypes.default.bool,
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  thumbnail: _propTypes.default.string,
  preload: _propTypes.default.string,
  partial: _propTypes.default.string
};